import { TFunction } from 'i18next'
import { Action } from '../Table/RowActions'
import { AwaitingDecisionRow } from './getAwaitingDecisionsTableColumns'
import { PotentialInviteStatus } from '@swagger'

export interface AwaitingDecisionsTableRowActionHandlers {
  onPass?: (row: AwaitingDecisionRow) => void
  onSendInvite?: (row: AwaitingDecisionRow) => void
  onFamilyDetails?: (row: AwaitingDecisionRow) => void
}

export const getAwaitingDecisionsTableRowActions = (
  t: TFunction,
  handlers?: AwaitingDecisionsTableRowActionHandlers
): Action<AwaitingDecisionRow>[] => [
  {
    actionKey: 'pass',
    actionName: t('Communities.AwaitingDecisionsTable.RowAction.Pass', 'Pass'),
    actionFunction: (row) => handlers?.onPass?.(row),
    disabled: !handlers?.onPass,
    hide: (row) => row?.status === PotentialInviteStatus.Declined,
  },
  {
    actionKey: 'sendInvite',
    actionName: t(
      'Communities.AwaitingDecisionsTable.RowAction.SendInvite',
      'Send Invite'
    ),
    actionFunction: (row) => handlers?.onSendInvite?.(row),
    disabled: !handlers?.onSendInvite,
    hide: (row) => row?.status === PotentialInviteStatus.Declined,
  },
  {
    actionKey: 'familyDetails',
    actionName: t(
      'Communities.AwaitingDecisionsTable.RowAction.FamilyDetails',
      'Family Details'
    ),
    actionFunction: (row) => handlers?.onFamilyDetails?.(row),
    disabled: !handlers?.onFamilyDetails,
  },
]
